import React from 'react';
import "./index.scss"
import {ReactComponent as NotFoundLogo} from '../../assets/icon-notfound.svg';


const NotFound = () => {
    return (<>
        <div className={"not-found"}>
            <div className={"header-text"}>网页错误</div>
            <div className={"sub-text"}>很抱歉您要找的网站发生了错误，请回到主页面。</div>
        </div>
        <span><NotFoundLogo className="not-found-logo"/></span></>)
}

export default NotFound;